import React from 'react';
import { Modal } from '../UI';

const OUTCOME_STYLE = {
  submit: { color: '#16a34a', bg: '#dcfce7', shadow: 'rgba(22,163,74,0.25)', heading: 'VOUCHER SUBMITTED!', icon: <polyline points="20 6 9 17 4 12" /> },
  approve: { color: '#16a34a', bg: '#dcfce7', shadow: 'rgba(22,163,74,0.25)', heading: 'VOUCHER APPROVED!', icon: <polyline points="20 6 9 17 4 12" /> },
  return: { color: '#f97316', bg: '#ffedd5', shadow: 'rgba(249,115,22,0.25)', heading: 'VOUCHER RETURNED!', icon: (<><polyline points="9 14 4 9 9 4" /><path d="M20 20v-7a4 4 0 0 0-4-4H4" /></>) },
  reject: { color: '#ef4444', bg: '#fee2e2', shadow: 'rgba(239,68,68,0.25)', heading: 'VOUCHER REJECTED!', icon: (<><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></>) },
  hold: { color: '#eab308', bg: '#fef9c3', shadow: 'rgba(234,179,8,0.25)', heading: 'VOUCHER ON HOLD!', icon: (<><rect x="6" y="4" width="4" height="16" /><rect x="14" y="4" width="4" height="16" /></>) },
  // Lifting a hold is the opposite outcome and needs its own face — pause
  // bars and "ON HOLD!" after a release read as though nothing had changed.
  resume: { color: '#16a34a', bg: '#dcfce7', shadow: 'rgba(22,163,74,0.25)', heading: 'HOLD LIFTED!', icon: <polygon points="6 3 20 12 6 21 6 3" /> },
  // Releasing into the Expense Register is a success and needs its own face.
  // Without this entry the lookup below fell through to `error`, so a release
  // that had worked announced itself as ACTION FAILED over a message saying
  // it had succeeded.
  release: { color: '#16a34a', bg: '#dcfce7', shadow: 'rgba(22,163,74,0.25)', heading: 'VOUCHER RELEASED!', icon: <polyline points="20 6 9 17 4 12" /> },
  post: { color: '#0b318b', bg: '#dbeafe', shadow: 'rgba(11,49,139,0.25)', heading: 'VOUCHER POSTED!', icon: <polyline points="20 6 9 17 4 12" /> },
  draft: { color: '#475569', bg: '#e2e8f0', shadow: 'rgba(71,85,105,0.25)', heading: 'SAVED AS DRAFT', icon: (<><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2Z" /><polyline points="17 21 17 13 7 13 7 21" /><polyline points="7 3 7 8 15 8" /></>) },
  error: { color: '#ef4444', bg: '#fee2e2', shadow: 'rgba(239,68,68,0.25)', heading: 'ACTION FAILED', icon: (<><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></>) },
  // Used only when an action has no entry of its own. Neutral on purpose:
  // see the note on the lookup below.
  done: { color: '#0b318b', bg: '#dbeafe', shadow: 'rgba(11,49,139,0.25)', heading: 'DONE', icon: <polyline points="20 6 9 17 4 12" /> },
};

export default function VoucherOutcomeModal({ outcome, onClose }) {
  if (!outcome) return null;
  // Falls back to `done`, not `error`. Every real failure sets type 'error'
  // explicitly, so an unrecognised type means an action nobody has styled yet
  // — and defaulting that to a red ACTION FAILED told users their work had
  // failed when it had just succeeded.
  const style = OUTCOME_STYLE[outcome.type] || OUTCOME_STYLE.done;
  return (
    <Modal title={outcome.title || style.heading} onClose={onClose} width={460}>
      <div style={{ textAlign: 'center', padding: '20px 10px' }}>
        <div style={{
          width: 72, height: 72, borderRadius: '50%', background: style.bg, border: `3px solid ${style.color}`,
          display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px auto',
          boxShadow: `0 0 24px ${style.shadow}`,
        }}>
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke={style.color} strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round">
            {style.icon}
          </svg>
        </div>
        <h3 style={{ fontSize: 20, fontWeight: 800, color: style.color, margin: '0 0 10px 0', letterSpacing: '-0.02em' }}>{style.heading}</h3>
        <p style={{ fontSize: 14, color: '#475569', lineHeight: 1.6, margin: '0 0 24px 0', maxWidth: 380, marginLeft: 'auto', marginRight: 'auto' }}>
          {outcome.message}
        </p>
        <button
          onClick={onClose}
          style={{ background: style.color, color: '#ffffff', border: 'none', padding: '12px 36px', borderRadius: 8, fontSize: 14, fontWeight: 700, cursor: 'pointer', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}
        >
          OK
        </button>
      </div>
    </Modal>
  );
}
